// Module
var code = `<div class="code-body" data-start-line data-end-line data-filter-syscall>
    <div class="code-metadata"><div class="code-title"> </div><label class="collapse-button"><input type=checkbox></label></div>
    <div class="code-filter"></div>
    <div class="code-snippet">
        <div class="parent-files"></div>
        <div class="parent-browser"></div>
        <pre class="line-numbers" data-start data-line-offset data-line><code class="language-c"> </code></pre>
    </div>
</div>
`;
// Exports
export default code;